var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfiniti(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 73,
    height: 73,
    viewBox: "0 0 73 73",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_399",
    x: 0,
    y: 0,
    width: 73,
    height: 73,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_29221",
    "data-name": "Group 29221",
    transform: "translate(212 10411)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -212, -10411)",
    filter: "url(#Ellipse_399)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_399-2",
    "data-name": "Ellipse 399",
    cx: 27.5,
    cy: 27.5,
    r: 27.5,
    transform: "translate(9 6)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_50576",
    "data-name": "Path 50576",
    d: "M38.819,20.174C38.072,13.715,29.923,9,19.449,9,9.1,9,.958,13.646.088,20.047A7.75,7.75,0,0,0,0,21.14a6.729,6.729,0,0,0,1.086,3.893c3.5,5.314,11.83,7.077,12.188,7.16l1.313.307,4.862-11.345L24.311,32.5l1.313-.306c.358-.083,8.685-1.847,12.188-7.16A6.731,6.731,0,0,0,38.9,21.141,7.448,7.448,0,0,0,38.819,20.174Zm-2.361,3.968c-3.187,4.835-11.337,6.738-11.337,6.738L19.449,17.914,13.776,30.88s-8.15-1.9-11.337-6.738a5.174,5.174,0,0,1-.818-2.986,6.226,6.226,0,0,1,.074-.891c.744-5.474,8.266-9.644,17.754-9.644,9.562,0,17.125,4.237,17.765,9.775a5.959,5.959,0,0,1,.063.759A5.174,5.174,0,0,1,36.458,24.142Z",
    transform: "translate(-195 -10398)",
    fill: "#9fa8da"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50577",
    "data-name": "Path 50577",
    d: "M28.345,32.966,22.673,20,17,32.966l.81,1.621,4.862-11.345,4.862,11.345Z",
    transform: "translate(-198.223 -10400.086)",
    fill: "#7986cb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50578",
    "data-name": "Path 50578",
    d: "M37.593,20.775C36.952,15.237,29.39,11,19.828,11c-9.488,0-17.01,4.17-17.754,9.644A6.226,6.226,0,0,0,2,21.535a5.174,5.174,0,0,0,.818,2.986c3.187,4.835,11.337,6.738,11.337,6.738l5.673-12.966L25.5,31.259s8.15-1.9,11.337-6.738a5.174,5.174,0,0,0,.818-2.986A5.959,5.959,0,0,0,37.593,20.775Zm-8.851,6.432L19.828,16.673,10.914,27.207s-7.293-2.061-7.293-5.673a4.928,4.928,0,0,1,.074-.8c.014-.083.03-.165.048-.248a5.263,5.263,0,0,1,.17-.611c.02-.059.035-.119.057-.178,1.542-4.038,8.066-7.08,15.859-7.08,7.137,0,13.2,2.553,15.356,6.084q.137.23.254.464c.046.092.088.183.129.276.072.165.139.33.194.5.04.119.07.24.1.361.036.138.075.276.1.415a5.015,5.015,0,0,1,.075.818C36.035,25.146,28.742,27.207,28.742,27.207Z",
    transform: "translate(-195.379 -10398.379)",
    fill: "#c5cae9"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfiniti);
export default __webpack_public_path__ + "static/media/infiniti.520f68d0e5950013a1c790482383f90d.svg";
export { ForwardRef as ReactComponent };